module.exports = {
    "auth0": {
        "domain": "gateway.lwolf.com",
        "clientId": "5kjmq0ZYwMBX0fu2SsgAPOBmgm6Ik3Wh",
        "responseType": "token id_token",
        "cacheLocation": "localstorage",
        "useRefreshTokens": true,
        "authorizationParams": {
            "redirect_uri": "https://home.lwolf.com/login",
            "audience": "https://lwt.auth0.com/userinfo",
            "scope": "openid profile email offline_access"
        }
    },
    "FORCE_HTTPS": "true",
    "PERMISSIONS_API_URL": "https://authorization.api.lwolf.com/v1",
    "FEATURES_API_URL": "https://features.api.lwolf.com/v1",
    "ACCOUNTING_API_URL": "https://accounting.api.lwolf.com/v1",
    "AUTHENTICATION_API_URL": "https://authentication.api.lwolf.com/v1",
    "RECONCILIATION_API_URL": "https://reconciliation.api.lwolf.com/v1",
    "PORTAL_LANDING_URL": "https://lwolf.force.com/Support/lw_LoneWolfLogin",
    "INSIGHTS_LANDING_URL": "https://insights.lwolf.com/",
    "INSIGHTS_LOGIN_URL": "https://insights.lwolf.com/",
    "ROSTER_API_URL": "https://roster.api.lwolf.com/v1",
    "BANKING_RECONCILIATION_LANDING_URL": "https://reconciliation.lwolf.com/financial/banking-reconciliation/reconciliation-landing/",
    "SALESFORCE_URL": "https://lwt.auth0.com/samlp/olbFf4ekMyAbN0zR8cvaNkR7CLWab3BT",
    "WOLFCONNECT_API_URL": "https://api.globalwolfweb.com/",
    "BACK_OFFICE_V4_LANDING_URL": "https://backoffice.lwolf.com/",
    "APP_INSIGHTS": {
        "connectionString": "InstrumentationKey=bd9006e0-3edf-4ef7-b2cb-8e3452ad7ab1;IngestionEndpoint=https://eastus-6.in.applicationinsights.azure.com/",
        "appId": "prod-home-ui"
    }
}
;